"use strict";
import FactorInvoiceService from "./factor_invoices_service";
import DocumentsService from "./documents_service";
import _ from "../util/underscore_extensions";
export const DocumentBrowserUpdateNotifier = {};
export function GroupIDGroupCreator(docs, documentGroups) {
  function addFactorInvoiceRelatedFields(groupHash, factorInvoiceId, batchDocuments) {
    const factorInvoice = FactorInvoiceService.getFetchedWithId(factorInvoiceId);
    if (factorInvoice) {
      groupHash.relatedDocumentsTitle = "Related Documents";
      groupHash.relatedDocuments = [];
      groupHash.relatedDocumentsLoading = true;
      groupHash.factorBrokerId = factorInvoice.factor_broker_id;
      groupHash.noDebtorSelected = factorInvoice.data["no_debtor_selected"];
      groupHash.sourceInvoiceNumber = factorInvoice.source_invoice_number;
      groupHash.debtorName = factorInvoice.debtor_name;
      const ids = _.difference(factorInvoice.document_ids, batchDocuments.map((d) => d.id));
      DocumentsService.getDocuments(ids).then((documents) => {
        groupHash.relatedDocuments = documents;
        groupHash.relatedDocumentsLoading = false;
        $(DocumentBrowserUpdateNotifier).trigger("updated");
      });
    }
  }
  function buildGroupHash(documentGroupObject, batchDocuments) {
    if (documentGroupObject) {
      let groupHash = {
        number: documentGroupObject.position,
        id: documentGroupObject.id,
        documents: [],
        name: "Group " + documentGroupObject.position,
        ignored: documentGroupObject.ignored,
        grouping_method: documentGroupObject.grouping_method
      };
      if (documentGroupObject.factor_invoice_id) {
        addFactorInvoiceRelatedFields(
          groupHash,
          documentGroupObject.factor_invoice_id,
          batchDocuments
        );
      }
      return groupHash;
    } else {
      return {
        number: "unassociated",
        id: null,
        documents: [],
        name: "Unassociated",
        ignored: false
      };
    }
  }
  function sortGroupHashes(groups) {
    return groups.sort(function(groupAHash, groupBHash) {
      if (groupAHash.number === "unassociated") return 1;
      if (groupBHash.number === "unassociated") return -1;
      return groupAHash.number - groupBHash.number;
    });
  }
  function groupDocuments(documents) {
    const groups = {};
    let documentGroupIds = _.uniq(documents.map((doc) => doc.document_group_id));
    documentGroupIds.forEach((documentGroupId) => {
      const documentGroupObject = _.findWhere(documentGroups, { id: documentGroupId });
      groups[documentGroupId] = buildGroupHash(documentGroupObject, documents);
    });
    documents.forEach((doc) => {
      let group = groups[doc.document_group_id];
      group.documents.push(doc);
    });
    return sortGroupHashes(_.values(groups));
  }
  let groupsFromDocuments = groupDocuments(docs);
  let groupsWithoutDocuments = _.reject(documentGroups, (group) => {
    return groupsFromDocuments.find((groupHash) => groupHash.id === group.id);
  }).map((group) => {
    return buildGroupHash(group, []);
  });
  return {
    groups: groupsFromDocuments,
    allGroups: sortGroupHashes(groupsFromDocuments.concat(groupsWithoutDocuments)),
    groupSelected: function(group, groups) {
      groups.forEach((g) => {
        g.selected = g === group;
      });
    }
  };
}
